import axios from "axios";
const deleteErros = async function (form) {
  try {
    let listErros = form.querySelectorAll("ul[data-error]");
    if (listErros.length > 0) {
      listErros.forEach((item) => item.remove());
    }
  } catch (Exception) {
    console.warn("Exception in deleteErros => " + Exception);
  }
};

if (document.querySelector(".gridForm__content")) {
  document.querySelector(".gridForm__content").addEventListener(
    "submit",
    async (event) => {
      try {
        if (!event.target.matches(".gridForm__content form.form-item")) return;
        event.preventDefault();
        let form = event.target;
        let url = form.querySelector('input[name="nameForm"]');
        let response = await axios({
          url: url.value,
          method: "POST",
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            HTTP_X_REQUESTED_WITH: "XMLHttpRequest",
          },
          data: new FormData(form),
        });
        let { success, errors, honeypot } = response.data;
        let btn = form.querySelector("button[type='submit']");
        await deleteErros(form);
        if (!success) {
          let { dataset } = form;
          let honeypotInput = form.querySelector(
            `[name="${dataset.honeypotName}"]`
          );
          if (honeypotInput) {
            honeypotInput.name = honeypot.name;
            honeypotInput.value = honeypot.hash;
            honeypotInput.id = honeypot.name;
            dataset.honeypotName = honeypot.name;
            dataset.honeypotValue = honeypot.hash;
          }

          for (let error in errors) {
            let errorElement = document.createElement("ul");
            errorElement.setAttribute("data-error", true);
            errorElement.style.color = "red";
            errorElement.style.padding = "0";
            errorElement.style.paddingLeft = "1.5rem";
            errorElement.style.paddingTop = "1rem";
            let field = form.querySelector(`[name="${error}"]`);
            if (field) {
              let stringError = "";
              errors[error].forEach((item) => {
                stringError += ` <li>${item}</li> `;
              });
              errorElement.innerHTML = stringError;
              field.insertAdjacentElement("afterend", errorElement);
            }
          }
          return btn.removeAttribute("disabled");
        }
        try {
          let linea = form.querySelector("input[name='nameForm']");
          gtag("event", "formulario_enviado", {
            event_category: "Form submit",
            event_label: "Formulario de " + linea ? linea.value : "",
          });
        } catch (Exception) {
          console.warn("Exception in gtag => " + Exception);
        }
        btn.setAttribute("disabled", "");
        return window.location.reload();
      } catch (Exception) {
        console.warn("Exception in submitForms => " + Exception);
      }
    },
    false
  );
}

let all_gridforms = document.querySelectorAll(".form-item");
if(all_gridforms.length>0){
  all_gridforms.forEach(el=>{
      el.addEventListener('freeform-on-submit', function (event) {
        const form = event.form;
        let notas_formulario = '';
        const tituloPipedrive = form.querySelector('[name="tituloPipedriveLead"]');
        const empresa = form.querySelector('[name="company"]');
        const notes = form.querySelector('[name="notas"]');
        const customfields = ["productoDeInteres","aplicacionDelProducto","message"]
        const checkboxes_asuntos = form.querySelectorAll('input[name="asunto[]"]:checked');
        if(checkboxes_asuntos.length > 0){
          const asuntos = Array.from(checkboxes_asuntos).map(checkbox => checkbox.value);
          const Asuntos_concatenados = asuntos.join(', '); // Separa por comas
          if(asuntos.length>0){
            notas_formulario = notas_formulario + ' Asunto: '+ Asuntos_concatenados+' \n';
          }
        }
        customfields.forEach(el=>{
          let field = form.querySelector(`[name="${el}"]`);
          if(field != undefined && field.value != ""){
            notas_formulario = notas_formulario + ` ${field.placeholder}: ${field.value} \n`;
          }
        });
        if(tituloPipedrive){
          if(!tituloPipedrive.value.includes(empresa.value)){
            tituloPipedrive.value = `[${tituloPipedrive.value}] [${empresa.value ?? ''}]`;
          }
        }
        if(notes){
          notes.value=notas_formulario;
        }
      });
  });
}